import { render } from "./LbrxSideMenu.vue?vue&type=template&id=a07e1894&scoped=true"
import script from "./LbrxSideMenu.vue?vue&type=script&lang=js"
export * from "./LbrxSideMenu.vue?vue&type=script&lang=js"

import "./LbrxSideMenu.vue?vue&type=style&index=0&id=a07e1894&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a07e1894"]])

export default __exports__